import VirtTable from './VirtTable';

export default VirtTable;
